import React, { useEffect, useRef, useState } from 'react'
import { motion, useMotionValue } from 'framer-motion'
import cn from 'classnames'

export function PannableArea({
  wrapperElem = undefined,
  wrapperClass = undefined,
  containerClass = undefined,
  onDragStart = undefined,
  onDragEnd = undefined,
  children,
}) {
  const panX = useMotionValue(0)

  const wrapperRef = useRef()
  const containerRef = useRef()

  const [wrapperWidth, setWrapperWidth] = useState(wrapperElem ? wrapperElem.offsetWidth : 9999)
  const [containerWidth, setContainerWidth] = useState(wrapperElem ? wrapperElem.offsetWidth : 9999)
  const [showLeftBumper, setShowLeftBumper] = useState(false)
  const [showRightBumper, setShowRightBumper] = useState(false)

  const draggable = containerWidth >= wrapperWidth

  // acts as componentDidMount
  useEffect(() => {
    if (containerRef.current && wrapperRef.current) {
      const wrapperWidth = wrapperRef.current.offsetWidth
      const containerWidth = containerRef.current.offsetWidth
      setWrapperWidth(wrapperWidth)
      setContainerWidth(containerWidth)
      if (containerWidth > wrapperWidth) setShowRightBumper(true)
    }
  }, [])

  useEffect(() => {
    const width = wrapperWidth - containerWidth
    const handlePanChange = (currentPanX) => {
      const diff = width - currentPanX
      if (!showLeftBumper && currentPanX < -10) setShowLeftBumper(true)
      if (showLeftBumper && currentPanX >= -10) setShowLeftBumper(false)
      if (!showRightBumper && diff < -10) setShowRightBumper(true)
      if (showRightBumper && diff >= -10) setShowRightBumper(false)
    }
    const unmountListener = panX.onChange(handlePanChange)
    return () => {
      unmountListener()
    }
  }, [wrapperWidth, containerWidth, showLeftBumper, showRightBumper])

  return (
    <div
      ref={wrapperRef}
      className={cn('pannable-area', wrapperClass)}
      style={{ cursor: draggable ? 'grab' : undefined }}>
      <motion.div
        ref={containerRef}
        className={containerClass}
        drag={draggable ? 'x' : undefined}
        style={{ x: panX }}
        dragElastic={0.05}
        dragConstraints={{ left: wrapperWidth - containerWidth, right: 0 }}
        onDragStart={(event, info) => {
          setWrapperWidth(wrapperRef.current.offsetWidth)
          setContainerWidth(containerRef.current.offsetWidth)
          onDragStart && onDragStart(event, info)
        }}
        onDragEnd={onDragEnd}>
        {children}
      </motion.div>
      <div className="bumper bumper-left" style={{ opacity: showLeftBumper ? 1 : 0 }} />
      <div className="bumper bumper-right" style={{ opacity: showRightBumper ? 1 : 0 }} />
    </div>
  )
}
